import { useToast } from '@drama/ui'

import { useAuditText } from './audit-text.js'

/** 复制到剪贴板并提示结果；短 id 与原始数据块共用。 */
export function useCopy() {
  const toast = useToast()
  const { tr } = useAuditText()
  return async function copy(text) {
    try {
      await navigator.clipboard.writeText(text)
      toast.success(tr('copied'))
    } catch (error) {
      toast.error(tr('copyFailed', { message: error.message }))
    }
  }
}
